<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1CUbEAj/tc-custom/9780715335369.jpg?1704286951528" alt="This image is the cover for the book Beader's Bible"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Beader's Bible
      </h1>
      <p class="bookDescription body article font2">
        <b>Beading techniques and over thirty beautiful projects for every experience level!</b><br/>  <br/> This is an indispensable guide to beads and beading techniques, presenting essential beading know-how together with a wide range of inspirational projects, tips and ideas.<br/>  <br/> Each chapter focuses on a different beading technique, guiding you through the basic skills, tools and materials, before tackling more advanced techniques and projects. <i>The Beader’s Bible</i> features over thirty “Bead Something Now” projects, ranging from bags and jewelry to stylish scarves and accessories—perfect excuses for trying out your new skills!<br/>  <br/> Easy-to-follow step-by-step instructions, clear diagrams, and stunning photography combine to create a must-have resource for beaders of all abilities.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dorothy Wood
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      D & C
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7aad02b5